module.exports = __webpack_public_path__ + "img/delete-app.67349649.png";